module.exports = __webpack_public_path__ + "static/image/history/pc/202103.jpg?b6aaf18f";